import React, { Component } from "react"
import { Modal, Button } from "react-bootstrap"

export default class Vmodal extends Component {
  constructor(props, context) {
    super(props, context)

    this.handleShow = this.handleShow.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.state = {
      show: false,
    }
  }

  handleClose() {
    this.setState({ show: false })
  }

  handleShow() {
    this.setState({ show: true })
  }

  render() {
    return (
      <>
        <button
          onClick={this.handleShow}
          className={this.props.buttonClassName}
        >
          {this.props.html}
        </button>

        <Modal
          size={this.props.size}
          show={this.state.show}
          onHide={this.handleClose}
          dialogClassName={this.props.mclass}
          centered
        >
          <Button onClick={this.handleClose} className="close" />
          <Modal.Body className={this.props.mbodyclass}>
            <div className="p-3 p-md-5">
              {this.props.children}
              <div className="text-center">
                <button
                  className="btn btn-primary btn-close-text"
                  onClick={this.handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}
